import { Link } from "react-router-dom";

const footerLinks = [
  { name: "Accueil", href: "/" },
  { name: "À propos", href: "/a-propos" },
  { name: "Recherches", href: "/recherches" },
  { name: "Ventes", href: "/ventes" },
  { name: "Valorisation", href: "/valorisation" },
  { name: "Honoraires", href: "/honoraires" },
  { name: "Nos trouvailles", href: "/nos-trouvailles" },
  { name: "FAQ", href: "/faq" },
  { name: "Contact", href: "/contact" },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-surface border-t border-line">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-14">
          {/* Brand */}
          <div className="space-y-5">
            <div>
              <span className="font-serif text-3xl font-semibold text-text-primary tracking-tight">
                Emplacement-Immo
              </span>
            </div>
            <p className="text-text-secondary text-sm leading-relaxed">
              Chasseur immobilier et agent immobilier à Paris et Grand Paris
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-text-primary text-xl mb-6">
              Liens rapides
            </h3>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-text-secondary hover:text-gold transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-serif text-text-primary text-xl mb-6">
              Contact
            </h3>
            <div className="space-y-4">
              <a
                href="mailto:infos@emplacement-immo.com"
                data-testid="footer-email"
                className="text-text-secondary hover:text-gold transition-colors text-sm block"
              >
                infos@emplacement-immo.com
              </a>
              <Link
                to="/mentions-legales"
                data-testid="footer-legal"
                className="text-text-secondary hover:text-gold transition-colors text-sm block"
              >
                Mentions légales
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-16 pt-8 border-t border-line">
          <p className="text-text-secondary text-sm text-center">
            Copyright © 2025 Emplacement-Immo. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};
